import { DownloadCSV } from '../../core/slots/DownloadCSV.js';
import { DONUT_CHART_DISPLAY_NAME } from '../constants.js';

export const DonutChartDownloadCSVSlot = DownloadCSV(DONUT_CHART_DISPLAY_NAME);
